/**
 * Phase upload-input-fixes — TODO-068
 *
 * SignatureStatusPill renders a small inline badge for document signature
 * detection results. Used on UploadDocsPage (existing docs table) and
 * DocumentsTabPanel (doc row renderer).
 *
 * Pill design:
 *   'digital' | 'digitally_signed' → green  "✓ Digitally Signed"
 *   'likely_signed'                → yellow "~ Likely Signed"
 *   'wet' | 'scanned'             → orange "⚠ Scanned PDF"
 *   'none' | null | undefined      → no pill (returns null)
 */

import type { ReactElement } from 'react';

export type SignatureStatusValue = string | null | undefined;

interface PillConfig {
  label: string;
  bg: string;
  color: string;
}

function resolveConfig(status: SignatureStatusValue): PillConfig | null {
  if (!status || status === 'none') return null;
  switch (status) {
    case 'digital':
    case 'digitally_signed':
      return { label: '✓ Digitally Signed', bg: '#dcfce7', color: '#15803d' };
    case 'likely_signed':
      return { label: '~ Likely Signed', bg: '#fef9c3', color: '#854d0e' };
    case 'wet':
    case 'scanned':
      return { label: '⚠ Scanned PDF', bg: '#ffedd5', color: '#c2410c' };
    default:
      return null;
  }
}

interface Props {
  status: SignatureStatusValue;
}

export function SignatureStatusPill({ status }: Props): ReactElement | null {
  const cfg = resolveConfig(status);
  if (!cfg) return null;

  return (
    <span
      data-testid="sig-status-pill"
      style={{
        display: 'inline-block',
        padding: '1px 7px',
        borderRadius: 10,
        fontSize: 11,
        fontWeight: 600,
        background: cfg.bg,
        color: cfg.color,
        whiteSpace: 'nowrap',
      }}
    >
      {cfg.label}
    </span>
  );
}
